import { render, staticRenderFns } from "./newPrintIcon.vue?vue&type=template&id=2b702db8"
import script from "./newPrintIcon.vue?vue&type=script&lang=js"
export * from "./newPrintIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports